import {
  UserGroupIcon,
  UserIcon,
  LockOpenIcon,
  CalendarIcon,
} from "@heroicons/react/outline";
import { useParams } from "react-router-dom";
import useMembers from "../../hooks/DatabseCollection/useMembers";
import useRoomId from "../../hooks/DatabseCollection/useRoomId";
import Moment from "react-moment";
import { ClipLoader } from "react-spinners";
// import moment from "moment";

const AboutTab = () => {
  const { roomId } = useParams();
  const { roomDetail, loading } = useRoomId(roomId);
  const [membersData] = useMembers(roomId);

  return (
    <div>
      {loading ? (
        <div className="flex justify-center mt-10">
          <ClipLoader color="black" loading={loading} size={70} />
        </div>
      ) : (
        <div className="space-y-5 sm:space-y-0 sm:flex sm:items-center sm:justify-between">
          <div className="flex items-center space-x-3">
            {roomDetail.createUserImage ? (
              <img
                src={roomDetail.createUserImage}
                alt="user"
                className="h-10 rounded-full shadow"
              />
            ) : (
              <UserIcon className="h-10 px-2 py-2 rounded-full bg-gray-100 border border-gray-300 shadow" />
            )}
            <h1 className="">
              Hosted By :
              <span className="text-gray-600 font-semibold">
                {roomDetail.createdUser}
              </span>{" "}
            </h1>
          </div>
          <div className="flex items-center space-x-5">
            <div className="flex items-center space-x-3">
              <LockOpenIcon className="h-6 text-green-500" />
              <h1>{roomDetail.privacyMode ? "Private Room" : "Public Room"}</h1>
            </div>
            <div className="flex items-center space-x-3">
              <UserGroupIcon className="h-6 text-green-500" />
              <p>{membersData.length} Members</p>
            </div>
            <div className="flex items-center space-x-3">
              <CalendarIcon className="h-6 text-green-500" />
              <Moment fromNow>{roomDetail.timestamp?.toDate()}</Moment>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutTab;
